import { render, staticRenderFns } from "./city-list.vue?vue&type=template&id=3ba860b3&scoped=true"
import script from "./city-list.vue?vue&type=script&lang=js"
export * from "./city-list.vue?vue&type=script&lang=js"
import style0 from "./city-list.vue?vue&type=style&index=0&id=3ba860b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba860b3",
  null
  
)

export default component.exports